import { COMPETERA_EXPERIMENT } from 'shared/experiments/consts'
import {
  COMPETERA_EXPERIMENT_CLICK_ON_PRODUCT_IN_CATEGORY,
  COMPETERA_EXPERIMENT_CLICK_ON_PRODUCT_IN_SLIDER,
} from 'shared/experiments/consts/events'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'

const isCompeteraExperimentEnabledOnClient = (): boolean => {
  const competeraExperiment = getExperimentOnClient(COMPETERA_EXPERIMENT)
  return Boolean(competeraExperiment?.isEnabled)
}
export const competeraExperimentTrackProductInSlider = (): void => {
  if (!isCompeteraExperimentEnabledOnClient()) {
    return
  }
  void activateExperiment(COMPETERA_EXPERIMENT)

  const sliders = document.querySelectorAll(
    '.o-CmsContent__ComponentLegacyProductBattery, [data-clientside-api-call~="fetchCrossSell"]'
  )

  const sliderTrackingEventListener = (event: Event) => {
    const target = <HTMLElement>event.target

    if (
      target.closest(
        '[data-clientside-hook~="slider__item"] .o-ProductSliderItem__main'
      ) ||
      target.closest(
        '[data-clientside-hook~="slider__item"] .o-ProductSliderItemWide__main'
      )
    ) {
      trackEvent(COMPETERA_EXPERIMENT_CLICK_ON_PRODUCT_IN_SLIDER)
      return
    }
  }

  sliders?.forEach(slider => {
    slider?.addEventListener('click', event => {
      sliderTrackingEventListener(event)
      return
    })
  })
}

const categoryListenerInitialized = new WeakSet<Element>()

export const competeraExperimentTrackProductInCategory = (): void => {
  if (!isCompeteraExperimentEnabledOnClient()) {
    return
  }

  const categoryContainers = document.querySelectorAll(
    '.o-SearchProductListItem'
  )

  const categoryTrackingEventListener = (event: Event) => {
    const target = <HTMLElement>event.target

    if (target.closest('.o-SearchProductListItem__link')) {
      trackEvent(COMPETERA_EXPERIMENT_CLICK_ON_PRODUCT_IN_CATEGORY)
    }
  }

  categoryContainers?.forEach(container => {
    if (!categoryListenerInitialized.has(container)) {
      container.addEventListener('click', categoryTrackingEventListener)
      categoryListenerInitialized.add(container)
    }
  })
}
